import React from "react";
import { Modal, Box, Typography } from "@mui/material";
import Button from "../../../componentsv2/Button";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "min(360px, 92vw)",
  backgroundColor: "#fff",
  borderRadius: "16px",
  boxShadow: "0 16px 40px rgba(0, 0, 0, 0.16)",
  padding: "20px",
};

export default function ModalConfirmacaoAcao({
  open,
  titulo = "Confirmar ação",
  descricao,
  textoConfirmar = "Confirmar",
  onConfirmar,
  onCancelar,
}) {
  return (
    <Modal open={open} onClose={onCancelar}>
      <Box sx={modalStyle}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          {titulo}
        </Typography>
        <Typography sx={{ color: "#4f5b6b", mb: 3 }}>{descricao}</Typography>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <Button variant="outlined" color="blue" onClick={onCancelar}>
            Cancelar
          </Button>
          <Button variant="contained" color="blue" onClick={onConfirmar}>
            {textoConfirmar}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
